





























import { Component, Vue } from "vue-property-decorator";
import { translate } from "@/utils";
import { PointSealsModule } from "@/store/pointseals.module";
import ExpansionPanel from "../ui/ExpansionPanel.vue";

@Component({
  components: { ExpansionPanel },
})
export default class PointSealsView extends Vue {
  get headers() {
    return [
      {
        text: this.$t("pointSeal.meter_seal_number"),
        value: "meter_seal_number",
        sortable: false,
      },
      {
        text: this.$t("pointSeal.seal_place_name"),
        value: "seal_place_name",
        sortable: false,
      },
      {
        text: this.$t("pointSeal.date_meter_seal_set"),
        value: "date_meter_seal_set",
        sortable: false,
      },
    ];
  }

  get sealsListPagination() {
    return PointSealsModule.sealsListPagination;
  }
  set sealsListPagination(val) {
    PointSealsModule.setSealsListPagination(val);
    this.loadSeals();
  }

  get loading() {
    return PointSealsModule.sealsListLoading;
  }

  get getSealsList() {
    return translate(PointSealsModule.sealsList);
  }

  get sealsListLength() {
    return PointSealsModule.sealsListLength;
  }

  async mounted() {
    PointSealsModule.setNewSealList();
    this.loadSeals();
  }

  loadSeals() {
    PointSealsModule.getSealsList({
      iAccountPointRid: parseInt(this.$route.params.pointId),
      iLimit: this.sealsListPagination.itemsPerPage,
      iOffset:
        this.sealsListPagination.itemsPerPage *
        (this.sealsListPagination.page - 1),
    });
  }
}
